import React from "react";
import { useDispatch } from 'react-redux';
import { logoutUser } from '../state/actions/userActions';


function LogoutButton(){
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
  };
    return (
        <button onClick={handleLogout} className="logout-button">
        Log out
      </button>
    )
}

export default LogoutButton;